import {
    type NodeCfg,
} from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';
import { accessor } from 'src/store';
import { ArgoWorkOrderStatusEnum } from 'types/db';

export const workOrderSetStatusUiNodeSpec: UiNodeSpec<'workOrderSetStatus'> = {
    kindLabel: 'Work Order Set Status',
    nodeCategory: 'argonautApi',
    requiredSockets: [ 'trigger' ],
    controls: getNodeCfg => {
        return {
            status: {
                nodeCfg: getNodeCfg(),
                value: getNodeCfg().controlValues.status,
                cfg: {
                    kind: 'selection',
                    items: [
                        { label: 'Staged', value: ArgoWorkOrderStatusEnum.Staged },
                        { label: 'Released', value: ArgoWorkOrderStatusEnum.Released },
                        { label: 'Completed', value: ArgoWorkOrderStatusEnum.Completed },
                        { label: 'Manually Completed', value: ArgoWorkOrderStatusEnum.ManuallyCompleted },
                    ],
                },
            },
        };
    },
    cfg: () => {
        const workOrderNodeCfg: NodeCfg<'workOrderSetStatus'> = {
            disabled: false,
            id: getUID(),
            kind: 'workOrderSetStatus',
            controlValues: {
                status: ArgoWorkOrderStatusEnum.Completed,
            },
        };
        return workOrderNodeCfg;
    },
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        statusNote: { socket: 'string', label: 'Status Note' },
        workOrderId: { socket: 'string', label: 'Work Order Id' },
    }),
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
    }),
    validator: () => true,
    suppressNode: () => !accessor.testFeatureFlagRequirements([ 'unstableWorkOrders' ]),
};
